import { useAtomValue } from 'jotai';

import pdpEditOrderErrorMessageAtom from './pdpEditOrderErrorMessageAtom';

const usePdpEditOrderErrorMessage = () => {
  const pdpEditOrderErrorMessage = useAtomValue(pdpEditOrderErrorMessageAtom);
  return pdpEditOrderErrorMessage;
};

export default usePdpEditOrderErrorMessage;
